import {Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute, RouterOutlet} from '@angular/router';
import {takeUntil} from 'rxjs';
import {AuthenticatedBaseComponent} from '../../authenticated-base.component';
import {TabSwitcherComponent} from '../../../components/tab-switcher/tab-switcher.component';
import {TabSwitcherConfig} from '../../../components/tab-switcher/tab-switcher-configuration.interface';
import {BackButtonComponent} from '../../../components/back-button/back-button.component';
import {ServiceProviderHub} from '@generated-backend-types';
import EventInquiry = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Eventmanagement.Event.Inquiry.EventInquiry;

@Component({
  selector: 'app-event-inquiry-detail-shell',
  templateUrl: './event-inquiry-detail-shell.component.html',
  imports: [RouterOutlet, TabSwitcherComponent, BackButtonComponent],
  standalone: true,
})
export class EventInquiryDetailShellComponent extends AuthenticatedBaseComponent implements OnInit {
  public inquiry?: EventInquiry;
  private activatedRoute = inject(ActivatedRoute);

  public get tabConfig(): TabSwitcherConfig[] {
    if (!this.inquiry) return [];
    const eventId = this.activatedRoute.snapshot.parent?.parent?.params['id'];
    const base = `/events/${eventId}/inquiries/${this.inquiry.id}`;
    return [
      {link: `${base}/event-overview`, translationKey: 'events.detail.inquiry.tabs.event_overview', exact: false},
      {link: `${base}/offer`, translationKey: 'events.detail.inquiry.tabs.offer', exact: false},
    ];
  }

  public ngOnInit(): void {
    this.titleService.setTitle('events.detail.inquiry.title');
    this.activatedRoute.data.pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.inquiry = data['inquiry'];
      this.cdr.markForCheck();
    });
  }

  public override ngAfterViewInit(): void {
    this.contentHeaderService.setContentHeaderFallback(this.contentHeaderTemplate);
  }
}
